import type { TFunction } from 'i18next';

import { Button, Spinner } from '@/shared/ui';

export interface ContinuePendingPaymentButtonProps {
  /** This order's request is in flight — shows the spinner. */
  pending: boolean;
  /** Another order's request is in flight. */
  disabled?: boolean;
  onClick: () => void;
  t: TFunction<'orders'>;
  size?: 'sm' | 'md';
}

export function ContinuePendingPaymentButton({
  pending,
  disabled = false,
  onClick,
  t,
  size = 'sm',
}: ContinuePendingPaymentButtonProps) {
  const blocked = pending || disabled;
  return (
    <Button
      type="button"
      size={size}
      variant="primary"
      disabled={blocked}
      aria-busy={pending}
      onClick={(event) => {
        event.stopPropagation();
        if (blocked) return;
        onClick();
      }}
    >
      {pending ? <Spinner size={14} label={t('continue.loading')} /> : null}
      {t('continue.action')}
    </Button>
  );
}
